import React from "react";
import { useSelector } from "react-redux";
import WidgetCarouselCard from "../../features/widget/widgetCarouselCard/WidgetCarouselCard";
import championshipImg from "../../../../assests/championship/widgetAlifut-he.png";

const ChampionshipCarouselWidget = () => {

    const { texts } = useSelector(state => state.translate);

    return (
        <WidgetCarouselCard
            color="#FDDB71"
            image={championshipImg}
            imageAlt={texts.championship}
            link="/myskillz"
            imageFill
        />
    );
};

export default ChampionshipCarouselWidget;
